import {ModuleController} from "../../infrastructure/controllers/module-controller";
import {BaseManagedService} from "../../infrastructure/domain-services/base-managed-service";
import {PropositionBetsWidgetConfig} from "./proposition-bets-widget.config";
import {PropositionBetsWidgetStore} from "./proposition-bets-widget.store";
import {PropositionBetsWidgetHandlers} from "./handlers/proposition-bets-widget.handlers";

export class PropositionBetsWidgetController extends ModuleController {
  static injectables = [...BaseManagedService.injectables, PropositionBetsWidgetConfig, PropositionBetsWidgetStore, PropositionBetsWidgetHandlers];

}
